module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-heart-ee497ef7045470dd315425259755312b.svg";